<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady" dir="rtl">
  <div class="row additem-content">
    <h2 class="additemhead">
      {{ isUpdatePage ? 'تعديل بيانات الدكتور' : 'إنشاء دكتور جديد' }}
    </h2>

    <form
      class="form"
      [formGroup]="data"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
      novalidate
    >
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-alert error" *ngIf="formErrorMessage">
            {{ formErrorMessage }}
          </div>

          <div class="server-errors" *ngIf="backendValidationErrors.length">
            <strong>الأخطاء القادمة من السيرفر:</strong>
            <ul>
              <li *ngFor="let err of backendValidationErrors">{{ err }}</li>
            </ul>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="name"
              placeholder="الاسم بالكامل *"
              [class.is-invalid]="isInvalid('name')"
            />

            <small class="error-text" *ngIf="isInvalid('name')">
              {{ getError('name') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="mobile"
              placeholder="رقم الموبايل *"
              [class.is-invalid]="isInvalid('mobile')"
            />

            <small class="error-text" *ngIf="isInvalid('mobile')">
              {{ getError('mobile') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="email"
              formControlName="email"
              placeholder="البريد الإلكتروني"
              [class.is-invalid]="isInvalid('email')"
            />

            <small class="error-text" *ngIf="isInvalid('email')">
              {{ getError('email') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="specialty"
              placeholder="التخصص"
              [class.is-invalid]="isInvalid('specialty')"
            />

            <small class="error-text" *ngIf="isInvalid('specialty')">
              {{ getError('specialty') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="residence_place"
              placeholder="مكان الإقامة"
              [class.is-invalid]="isInvalid('residence_place')"
            />

            <small class="error-text" *ngIf="isInvalid('residence_place')">
              {{ getError('residence_place') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="birth_place"
              placeholder="مكان الميلاد"
              [class.is-invalid]="isInvalid('birth_place')"
            />

            <small class="error-text" *ngIf="isInvalid('birth_place')">
              {{ getError('birth_place') }}
            </small>
          </div>

          <div class="form-group">
            <label class="date-label">تاريخ الميلاد</label>
            <input
              class="input"
              type="date"
              formControlName="birth_date"
              placeholder="تاريخ الميلاد"
              [class.is-invalid]="isInvalid('birth_date')"
            />

            <small class="error-text" *ngIf="isInvalid('birth_date')">
              {{ getError('birth_date') }}
            </small>
          </div>

          <div class="form-group check-row degree-check">
            <label>
              <input type="checkbox" formControlName="has_phd" />
              حاصل على دكتوراه
            </label>
          </div>

          <div class="degree-box" *ngIf="data.get('has_phd')?.value">
            <h5>بيانات الدكتوراه</h5>

            <div class="form-group">
              <input
                class="input"
                type="text"
                formControlName="phd_source"
                placeholder="مصدر الدكتوراه *"
                [class.is-invalid]="isInvalid('phd_source')"
              />

              <small class="error-text" *ngIf="isInvalid('phd_source')">
                {{ getError('phd_source') }}
              </small>
            </div>

            <div class="form-group">
              <input
                class="input"
                type="number"
                formControlName="phd_year"
                placeholder="سنة الدكتوراه *"
                min="1940"
                max="2100"
                [class.is-invalid]="isInvalid('phd_year')"
              />

              <small class="error-text" *ngIf="isInvalid('phd_year')">
                {{ getError('phd_year') }}
              </small>
            </div>
          </div>

          <div class="form-group check-row degree-check">
            <label>
              <input type="checkbox" formControlName="has_master" />
              حاصل على ماجستير
            </label>
          </div>

          <div class="degree-box" *ngIf="data.get('has_master')?.value">
            <h5>بيانات الماجستير</h5>

            <div class="form-group">
              <input
                class="input"
                type="text"
                formControlName="master_source"
                placeholder="مصدر الماجستير *"
                [class.is-invalid]="isInvalid('master_source')"
              />

              <small class="error-text" *ngIf="isInvalid('master_source')">
                {{ getError('master_source') }}
              </small>
            </div>

            <div class="form-group">
              <input
                class="input"
                type="number"
                formControlName="master_year"
                placeholder="سنة الماجستير *"
                min="1940"
                max="2100"
                [class.is-invalid]="isInvalid('master_year')"
              />

              <small class="error-text" *ngIf="isInvalid('master_year')">
                {{ getError('master_year') }}
              </small>
            </div>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="university"
              placeholder="الجامعة"
              [class.is-invalid]="isInvalid('university')"
            />

            <small class="error-text" *ngIf="isInvalid('university')">
              {{ getError('university') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="number"
              formControlName="graduation_year"
              placeholder="سنة التخرج"
              min="1940"
              max="2100"
              [class.is-invalid]="isInvalid('graduation_year')"
            />

            <small class="error-text" *ngIf="isInvalid('graduation_year')">
              {{ getError('graduation_year') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="fellowship"
              placeholder="الزمالة"
              [class.is-invalid]="isInvalid('fellowship')"
            />

            <small class="error-text" *ngIf="isInvalid('fellowship')">
              {{ getError('fellowship') }}
            </small>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="classification_status"
              placeholder="حالة التصنيف"
              [class.is-invalid]="isInvalid('classification_status')"
            />

            <small class="error-text" *ngIf="isInvalid('classification_status')">
              {{ getError('classification_status') }}
            </small>
          </div>

          <div class="form-group check-row">
            <label>
              <input type="checkbox" formControlName="ksa_experience" />
              لديه خبرة في السعودية
            </label>
          </div>

          <div class="form-group check-row">
            <label>
              <input type="checkbox" formControlName="transfer_of_sponsorship" />
              نقل الكفالة
            </label>
          </div>

          <div class="form-group check-row">
            <label>
              <input type="checkbox" formControlName="visa" />
              التأشيرة
            </label>
          </div>

          <div class="form-group check-row">
            <label>
              <input type="checkbox" formControlName="has_dataflow" />
              حاصل على الداتافلو
            </label>
          </div>

          <!-- صورة الدكتور -->
          <div class="form-group upload-box image-upload-box">
            <div>
              <strong>صورة الدكتور</strong>
              <p>ارفع صورة شخصية للدكتور بصيغة JPG أو PNG أو WEBP</p>
            </div>

            <div class="image-preview-wrap" *ngIf="imagePreviewUrl">
              <img
                class="doctor-preview-img"
                [src]="imagePreviewUrl"
                alt="صورة الدكتور"
              />

              <div>
                <strong>
                  {{ selectedImage ? selectedImage.name : 'الصورة الحالية' }}
                </strong>
                <span>
                  {{ selectedImage ? 'تم اختيار صورة جديدة' : 'الصورة المرفوعة حاليًا' }}
                </span>
              </div>
            </div>

            <div class="empty-image-preview" *ngIf="!imagePreviewUrl">
              لا توجد صورة مختارة
            </div>

            <input
              #imageInput
              type="file"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              hidden
              (change)="onImageChange($event)"
            />

            <button type="button" class="upload-btn" (click)="imageInput.click()">
              {{ imagePreviewUrl ? 'تغيير الصورة' : 'اختيار الصورة' }}
            </button>

            <button
              *ngIf="selectedImage"
              type="button"
              class="remove-file-btn"
              (click)="removeImage()"
            >
              حذف الصورة المختارة
            </button>

            <small class="error-text" *ngIf="imageErrorMessage">
              {{ imageErrorMessage }}
            </small>
          </div>

          <!-- الشهادات -->
          <div class="form-group upload-box">
            <div>
              <strong>الشهادات و السي في</strong>
              <p>صور أو PDF بحد أقصى 20 ملف</p>
            </div>

            <input
              #certificatesInput
              type="file"
              accept=".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf"
              multiple
              hidden
              (change)="onCertificatesChange($event)"
            />

            <button
              type="button"
              class="upload-btn"
              (click)="certificatesInput.click()"
            >
              {{
                selectedCertificates.length
                  ? 'إضافة ملفات أخرى'
                  : 'اختيار الشهادات'
              }}
            </button>

            <button
              *ngIf="selectedCertificates.length"
              type="button"
              class="remove-file-btn"
              (click)="clearCertificates()"
            >
              حذف كل الشهادات
            </button>

            <small class="error-text" *ngIf="certificateErrorMessage">
              {{ certificateErrorMessage }}
            </small>

            <div class="selected-files" *ngIf="selectedCertificates.length">
              <p>الملفات المختارة: {{ selectedCertificates.length }} / 20</p>

              <div
                class="selected-file-row"
                *ngFor="let file of selectedCertificates; let i = index; trackBy: trackByFile"
              >
                <span>{{ file.name }}</span>

                <button
                  type="button"
                  class="remove-file-btn"
                  (click)="removeCertificate(i)"
                >
                  حذف
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <textarea
              class="input"
              formControlName="notes"
              placeholder="ملاحظات"
              rows="4"
              [class.is-invalid]="isInvalid('notes')"
            ></textarea>

            <small class="error-text" *ngIf="isInvalid('notes')">
              {{ getError('notes') }}
            </small>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="fromsave accont"
              [disabled]="isSubmitting"
            >
              {{
                isSubmitting
                  ? 'جاري الحفظ...'
                  : isUpdatePage
                    ? 'تعديل'
                    : 'إنشاء دكتور'
              }}
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>